import { type BatteryConfigRow, type WatchMessages, getBatteryConfigValue } from 'greener-ui-library';

export const COMMAND_CENTER_TAB_PARAM = 'tab';

export const HMI_TABS = [
  { key: 'overview', translationKey: 'overview', isMobileOnly: false },
  { key: 'power', translationKey: 'power', isMobileOnly: false },
  { key: 'battery', translationKey: 'battery', isMobileOnly: false },
  { key: 'assets', translationKey: 'assets', isMobileOnly: false },
  { key: 'commands', translationKey: 'commands', isMobileOnly: true },
] as const;

export const getBatteryChargeCriticalState = ({
  messages,
  batteryConfigRows,
}: {
  messages: WatchMessages;
  batteryConfigRows?: BatteryConfigRow[];
}) => {
  const soc = typeof messages.timeseries?.payload.ts.soc === 'number' ? messages.timeseries.payload.ts.soc : undefined;
  const emergencyGuardEnabled = Boolean(
    getBatteryConfigValue({ batteryConfigRows, name: 'enable_soc_emergency_guard' })
  );
  const criticalSocThreshold = Number(getBatteryConfigValue({ batteryConfigRows, name: 'soc_min_vs_error' }));

  const isCritical =
    emergencyGuardEnabled &&
    typeof soc === 'number' &&
    Number.isFinite(criticalSocThreshold) &&
    soc <= criticalSocThreshold;

  return {
    currentSoc: soc,
    criticalSocThreshold: Number.isFinite(criticalSocThreshold) ? criticalSocThreshold : undefined,
    isCritical,
  };
};
